import { render, staticRenderFns } from "./s2-4.vue?vue&type=template&id=f335ed9a&scoped=true&"
import script from "./s2-4.vue?vue&type=script&lang=js&"
export * from "./s2-4.vue?vue&type=script&lang=js&"
import style0 from "./s2-4.vue?vue&type=style&index=0&id=f335ed9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f335ed9a",
  null
  
)

export default component.exports